import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { DappProvider } from "@multiversx/sdk-dapp/wrappers";
import * as DappUI from "@multiversx/sdk-dapp/UI";
import App from "App";
import "assets/css/App.css";
import React from "react";
import ReactDOM from "react-dom";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { BrowserRouter } from "react-router-dom";
import theme from "theme/theme";
import "./assets/css/ElrondModules.css";

ReactDOM.render(
  <>
    <DappProvider
      environment="mainnet"
      customNetworkConfig={{
        name: "customConfig",
        apiTimeout: 6000,
        walletConnectV2ProjectId: "cb38e35136a0373d9351535625c6ced4",
      }}
    >
      <DappUI.SignTransactionsModals />
      <DappUI.NotificationModal />
      <ReactNotifications />
      <DappUI.TransactionsToastList />
      <ColorModeScript initialColorMode="dark" />
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </BrowserRouter>
      </ChakraProvider>
    </DappProvider>
  </>,
  document.getElementById("root")
);
